import wp from "wp";
import $ from "jquery";
/**
 * WordPress 5.4 - 5.6 has issues with caching in their media dialog. Apply the official changeset for
 * the fix for WordPress 5.7 to old versions.
 *
 * @see https://core.trac.wordpress.org/ticket/52650
 * @see https://core.trac.wordpress.org/changeset/50067
 * @see https://github.com/WordPress/WordPress/blob/9ff4499281663b0c772787fd4a60538288f842e9/wp-includes/js/media-models.js#L923-L930
 * @see https://github.com/WordPress/WordPress/blob/9ff4499281663b0c772787fd4a60538288f842e9/wp-includes/js/media-models.js#L1325-L1404
 */

function patchWpMediaDialogCacheIssue() {
  const {
    _
  } = window;

  if (!$("body").hasClass("branch-5-4") && !$("body").hasClass("branch-5-5") && !$("body").hasClass("branch-5-6")) {
    return;
  }

  wp.media.model.Attachments.prototype._requery = function () {
    var props;

    if (this.props.get("query")) {
      props = this.props.toJSON();
      this.mirror(wp.media.model.Query.get(props));
    }
  };

  const {
    Query
  } = wp.media.model;

  wp.media.model.Query.get = function () {
    var queries = [];
    return function (props, options) {
      var args = {},
          orderby = Query.orderby,
          defaults = Query.defaultProps,
          query;
      delete props.query;

      _.defaults(props, defaults);

      props.order = props.order.toUpperCase();

      if ("DESC" !== props.order && "ASC" !== props.order) {
        props.order = defaults.order.toUpperCase();
      }

      if (!_.contains(orderby.allowed, props.orderby)) {
        props.orderby = defaults.orderby;
      }

      _.each(["include", "exclude"], function (prop) {
        if (props[prop] && !_.isArray(props[prop])) {
          props[prop] = [props[prop]];
        }
      });

      _.each(props, function (value, prop) {
        if (_.isNull(value)) {
          return;
        }

        args[Query.propmap[prop] || prop] = value;
      });

      _.defaults(args, Query.defaultArgs);

      args.orderby = orderby.valuemap[props.orderby] || props.orderby;
      queries = [];

      if (!query) {
        query = new Query([], _.extend(options || {}, {
          props: props,
          args: args
        }));
        queries.push(query);
      }

      return query;
    };
  }();
}

export { patchWpMediaDialogCacheIssue };